import { render, staticRenderFns } from "./CreateRoomModal.vue?vue&type=template&id=a484baa8&"
import script from "./CreateRoomModal.vue?vue&type=script&lang=js&"
export * from "./CreateRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports